import React, { useEffect, useRef, useState } from 'react'

import { useIntl } from 'react-intl'
import {
  Button,
  Loading,
  MessageBox,
  Modal,
  MODAL_SIZE_XL,
  ModalBody,
  ModalFoot,
  ModalHead,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { modalPreview } from 'Pages/MessageEdit/recoil/state/modals'

import {
  discardAutosaveCallback,
  resumeAutosaveCallback
} from 'Pages/MessageEdit/recoil/callbacks/callbacks'
import { Previewer } from 'Components/PreviewTool/Previewer'
import { logAppError } from 'Helpers/logger'

import classnames from 'classnames'
import { getHTMLFromStructure } from 'Pages/MessageEdit/recoil/actions/actions'
import { editorState } from 'Pages/MessageEdit/recoil/state/editor'
import styled from '@emotion/styled'

export const ModalPreview = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalPreview)
  const { autosaveStructure } = useRecoilValue(editorState)
  const discardAutosave = useRecoilCallback(discardAutosaveCallback, [])
  const resumeAutosave = useRecoilCallback(resumeAutosaveCallback, [])
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)

  const content = useRef(null)

  useEffect(() => {
    const fetch = async () => {
      try {
        if (autosaveStructure) {
          // ATTENZIONE chiama direttamente il BEE
          content.current = await getHTMLFromStructure(autosaveStructure)
        }
      } catch (error) {
        // logAppError({ appError: error })
        setError(true)
      }
      setLoading(false)
    }

    fetch()
  }, [autosaveStructure])

  const handleDiscard = () => {
    discardAutosave()
  }

  const handleResume = () => {
    resumeAutosave()
  }

  return (
    <Modal
      show={show}
      size={MODAL_SIZE_XL}
      showClose={false}
      closeOnOverlayClick={false}
      data-mu-test='modal-message-preview'
    >
      {error ? (
        <MessageBox variant='danger'>
          {intl.formatMessage({ id: 'Load.Common.Error' })}
        </MessageBox>
      ) : loading ? (
        <Loading open />
      ) : (
        <>
          <ModalHead
            title={intl.formatMessage({
              id: 'Load.Bee.ModalForContinueEditingTemplatePreviewTitle'
            })}
          />
          <ModalBody>
            {intl.formatMessage({
              id: 'Load.Bee.ModalForContinueEditingTemplatePreviewContent'
            })}
            <div>
              <StyledDiv
                data-mu-test={classnames(
                  'desktop-preview',
                  'desktop-preview--active'
                )}
                className={classnames(
                  't-preview__preview',
                  't-preview__preview--active'
                )}
              >
                <Previewer
                  content={content.current}
                  sandbox={'allow-same-origin'}
                  comesFromBeeModalPreview
                />
              </StyledDiv>
            </div>
          </ModalBody>
          <ModalFoot>
            <Flex justifyContent='space-between' width='100%'>
              <StyledNeutralButton
                data-mu-test='button-message-preview-discard'
                onClick={handleDiscard}
                kind='neutral'
              >
                {intl.formatMessage({
                  id: 'Load.Bee.ModalForContinueEditingTemplateStartNewBtn'
                })}
              </StyledNeutralButton>

              <FlexItem>
                <Button
                  data-mu-test='button-message-preview-resume'
                  onClick={handleResume}
                  kind='secondary'
                >
                  {intl.formatMessage({
                    id: 'Load.Bee.ModalForContinueEditingTemplateContinueBtn'
                  })}
                </Button>
              </FlexItem>
            </Flex>
          </ModalFoot>
        </>
      )}
    </Modal>
  )
}

const StyledNeutralButton = styled(Button)`
  margin-left: 0 !important;
`

const StyledDiv = styled.div`
  .c-previewer__display {
    iframe {
      border: 2px solid var(--geyser);
    }
  }
`
